<template>
  <div class="flex h-full min-h-full w-full">
    <slot />
  </div>
</template>
<script setup lang="ts"></script>
